export default "/_next/static/images/9cb8432331f93e8062b305a63724deb1.jpg";